export const TicketsRoutes = {
  Overview: 'overview',
} as const;
